import { Action } from '@ngrx/store';

export enum ImportActionType {
  IMPORTING = '[ARTICLE] import tool',
}

export class ImportAction implements Action {

  readonly type = ImportActionType.IMPORTING;
  constructor(public payload: any) { }

}

export type ImportingAction = ImportAction;